export default "__VITE_ASSET__0b64e619__"